import Dialog from "../../atoms/dialog";
import { useState } from 'react'
import DeleteUserTrigger from "../user_triggers/DeleteUserTrigger";

const DeleteUserTriggerAlert = (props) => {
    const { onCompletion, userTriggerId, onClose } = props; 
    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (

        <Dialog
            // title={"Delete"}
            container_id={"delete_usertrigger"}
            open={true}
            handleClose={handleClose}
        >        
        <DeleteUserTrigger  onCompletion={onCompletion} userTriggerId={userTriggerId} onClose={onClose} />
        </Dialog >
    )
}

export default DeleteUserTriggerAlert;